var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-info",
              attrs: { type: "button" },
              on: { click: _vm.consultar }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _c("span", [_vm._v("Consultar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-success",
              attrs: { type: "button" },
              on: { click: _vm.exportar }
            },
            [
              _c("i", { staticClass: "fa fa-file-excel-o" }),
              _c("span", [_vm._v("Excel")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "tipo_fecha",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "H" } }, [_vm._v("Hoy")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "A" } }, [_vm._v("Ayer")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "P" } }, [
                      _vm._v("Personalizado")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "tipo_fecha" } }, [
                  _vm._v("Tipo de fecha")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.tipo_fecha === "P",
                  expression: "form.tipo_fecha === 'P'"
                }
              ],
              staticClass: "col-xs-12 col-md-4"
            },
            [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "desde",
                        locale: "es",
                        "no-label": "",
                        "only-date": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.desde,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "desde", $$v)
                        },
                        expression: "form.desde"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Desde")])
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.tipo_fecha === "P",
                  expression: "form.tipo_fecha === 'P'"
                }
              ],
              staticClass: "col-xs-12 col-md-4"
            },
            [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "hasta",
                        locale: "es",
                        "no-label": "",
                        "only-date": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.hasta,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "hasta", $$v)
                        },
                        expression: "form.hasta"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Hasta")])
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c(
              "div",
              { staticClass: "form-field select2 select2-field--stretch" },
              [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        filterable: false,
                        label: "descripcion",
                        placeholder: "Seleccione...",
                        options: _vm.bodegas,
                        id: "bodegas"
                      },
                      on: { input: _vm.inputBodega },
                      model: {
                        value: _vm.selectedBodega,
                        callback: function($$v) {
                          _vm.selectedBodega = $$v
                        },
                        expression: "selectedBodega"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "bodegas" } }, [
                      _vm._v("Sucursal")
                    ])
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      filterable: false,
                      label: "nombre",
                      placeholder: "Seleccione...",
                      options: _vm.recaudadores,
                      id: "usuarios"
                    },
                    on: {
                      search: _vm.onSearchUsuarios,
                      input: _vm.inputRecaudador
                    },
                    model: {
                      value: _vm.selectedRecaudador,
                      callback: function($$v) {
                        _vm.selectedRecaudador = $$v
                      },
                      expression: "selectedRecaudador"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "usuarios" } }, [
                    _vm._v("Recaudador")
                  ])
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.recaudaciones.length > 0,
            expression: "recaudaciones.length > 0"
          }
        ],
        staticClass: "card"
      },
      [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c(
                "div",
                {
                  staticClass: "table-responsive",
                  staticStyle: { "max-height": "300px" }
                },
                [
                  _c("table", { staticClass: "custom-table" }, [
                    _c("thead", [
                      _c(
                        "tr",
                        [
                          _c("th", [_vm._v("Recaudador")]),
                          _vm._v(" "),
                          _vm._l(_vm.registros, function(registro, index) {
                            return _c("th", { key: index }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(index) +
                                  "\n                  "
                              )
                            ])
                          }),
                          _vm._v(" "),
                          _c("th", [_vm._v("Total")])
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.recaudaciones, function(recaudador) {
                        return _c(
                          "tr",
                          { key: recaudador.nombre_recaudador },
                          [
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(recaudador.nombre_recaudador) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.registros, function(registro, index) {
                              return _c("td", { key: index }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      recaudador[index] != null
                                        ? _vm.moneyFormat(recaudador[index])
                                        : ""
                                    ) +
                                    "\n                  "
                                )
                              ])
                            }),
                            _vm._v(" "),
                            _c("td", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.moneyFormat(recaudador.total))
                                )
                              ])
                            ])
                          ],
                          2
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c(
                        "tr",
                        [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Total")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.registros, function(registro, index) {
                            return _c("td", { key: index }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.moneyFormat(_vm.obtenerTotalDia(index))
                                  )
                                )
                              ])
                            ])
                          }),
                          _vm._v(" "),
                          _c("td", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.moneyFormat(_vm.totalRecaudado))
                              )
                            ])
                          ])
                        ],
                        2
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Recaudación Diaria")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0579b61e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0579b61e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/RecaudacionDiaria.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0579b61e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/RecaudacionDiaria.vue
// module chunks = 0